export default {
    data() {
        return {
            currentQuery: {
                page: 1,
                sort_by: null,
                sort_order: "asc"
            },
            routeName: null
        };
    },
    methods: {
        updateTableSorting(activeTab) {
            if (activeTab) {
                this.$refs["tab_" + activeTab].$refs.table.sort(
                    this.currentQuery.sort_by,
                    this.currentQuery.sort_order === "desc"
                        ? "descending"
                        : "ascending"
                );
            } else {
                this.$refs.table.sort(
                    this.currentQuery.sort_by,
                    this.currentQuery.sort_order === "desc"
                        ? "descending"
                        : "ascending"
                );
            }
        },
        updateRoute() {
            //console.log("updateRoute");
            this.$router
                .push({
                    name: this.routeName,
                    query: this.currentQuery
                })
                .catch((e) => {
                    console.log("updateRoute", e);
                });
        },
        onCurrentPageChange(page) {
            //console.log("onCurrentPageChange");
            this.currentQuery.page = page;
            this.updateRoute();
        },
        onSortChange({ prop, order }) {
            let sort_order = null;
            let sort_by = prop;
            if (order) {
                sort_order = order === "descending" ? "desc" : "asc";
            } else {
                sort_by = null;
            }
            let has_update =
                JSON.stringify(
                    _.pick(this.currentQuery, ["sort_by", "sort_order"])
                ) !==
                JSON.stringify({
                    sort_by,
                    sort_order
                });
            this.currentQuery.sort_by = sort_by;
            this.currentQuery.sort_order = sort_order;
            if (has_update) {
                this.currentQuery.page = 1;
                this.updateRoute();
            }
        }
    }
};
